import axios from 'axios';

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;

const api = axios.create({
  baseURL: `${BACKEND_URL}/api`,
  headers: { 'Content-Type': 'application/json' },
});

api.interceptors.request.use((config) => {
  const token = localStorage.getItem('token');
  if (token) {
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

api.interceptors.response.use(
  (response) => response,
  (error) => {
    // Only redirect on 401 if it's an actual auth error, not a network issue
    if (error.response?.status === 401) {
      const path = window.location.pathname;
      const isPublic = path === '/' || path.startsWith('/reserver') || path.startsWith('/confirmation') || path.startsWith('/admin/login') || path.startsWith('/admin/register') || path.startsWith('/admin/forgot-password') || path.startsWith('/guest') || path.startsWith('/menu');

      if (!isPublic) {
        localStorage.removeItem('token');
        sessionStorage.removeItem('era_lodge_token');
        localStorage.removeItem('era_lodge_token');
        window.location.href = '/admin/login';
      }
    }
    return Promise.reject(error);
  }
);

export default api;

// API helpers
export const propertiesApi = {
  getAll: () => api.get('/properties'),
  create: (data) => api.post('/properties', data),
  update: (id, data) => api.put(`/properties/${id}`, data),
  delete: (id) => api.delete(`/properties/${id}`),
};

export const reservationsApi = {
  getAll: (params) => api.get('/reservations', { params }),
  create: (data) => api.post('/reservations', data),
  delete: (id) => api.delete(`/reservations/${id}`),
};

export const expensesApi = {
  getAll: (params) => api.get('/expenses', { params }),
  create: (data) => api.post('/expenses', data),
  delete: (id) => api.delete(`/expenses/${id}`),
};

export const platformSyncApi = {
  getAll: (params) => api.get('/platform-sync', { params }),
  create: (data) => api.post('/platform-sync', data),
  trigger: (id) => api.post(`/platform-sync/${id}/trigger`),
  delete: (id) => api.delete(`/platform-sync/${id}`),
};

export const analyticsApi = {
  getSummary: (params) => api.get('/analytics/summary', { params }),
  getCalendarEvents: (params) => api.get('/calendar/events', { params }),
};

export const receiptsApi = {
  upload: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/receipts/upload', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
  scan: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/receipts/scan', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};

export const notificationsApi = {
  getAll: () => api.get('/notifications'),
  markRead: (id) => api.put(`/notifications/${id}/read`),
  markAllRead: () => api.put('/notifications/read-all'),
  delete: (id) => api.delete(`/notifications/${id}`),
};

export const settingsApi = {
  updateNotifications: (data) => api.put('/auth/notification-settings', data),
  uploadSound: (file) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post('/settings/upload-sound', formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};

export const importApi = {
  importCSV: (file, propertyId) => {
    const formData = new FormData();
    formData.append('file', file);
    return api.post(`/import/csv?property_id=${propertyId}`, formData, {
      headers: { 'Content-Type': 'multipart/form-data' },
    });
  },
};
